import { render, staticRenderFns } from "./List-Intern.vue?vue&type=template&id=37ddb144"
import script from "./List-Intern.vue?vue&type=script&lang=js"
export * from "./List-Intern.vue?vue&type=script&lang=js"
import style0 from "./List-Intern.vue?vue&type=style&index=0&id=37ddb144&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports